import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "session-info-box p-3 rounded-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Title: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Day/Date: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Time: ", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Session Info: ", -1)
const _hoisted_7 = ["innerHTML"]

import { Event as ClassroomEvent } from '@/types/api'
import { createDateFormatter, checkIsValidEventTiming } from '../SessionRegistryStore/SessionRegistryStore.utils'
import { formatTimeRange } from '@/utils/date'
import { PropType, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LsatCoachingSessionInfoBox',
  props: {
  coachingSession: {
    type: Object as PropType<ClassroomEvent>,
    required: true
  },
  includeDescription: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props
const displayDate = computed(() => {
  if (!checkIsValidEventTiming(props.coachingSession.meetingOccurrences)) {
    return 'Invalid Date'
  }
  const formatter = createDateFormatter(props.coachingSession.meetingOccurrences)
  return formatter.startLocalDateTime.toLocaleString({
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(__props.coachingSession.title), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(displayDate.value), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_unref(formatTimeRange)(__props.coachingSession)), 1)
    ]),
    (__props.includeDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", {
            class: "session-description",
            innerHTML: __props.coachingSession.description
          }, null, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})